export enum CloneMetadataField {
  STATE = 'stateID',
  COUNTY = 'countyID',
  TMS_PARCEL_NUMBERS = 'tmsParcelNumbers',
  ADDRESS = 'address',
  SUBDIVISION = 'subdivision'
}

export const getMetadataFieldForIndex = (index: number): CloneMetadataField | undefined => {
  switch (index) {
  case 2:
    return CloneMetadataField.STATE;
  case 3:
    return CloneMetadataField.COUNTY;
  case 4:
    return CloneMetadataField.TMS_PARCEL_NUMBERS;
  case 5:
    return CloneMetadataField.ADDRESS;
  case 6:
    return CloneMetadataField.SUBDIVISION;
  default:
    return undefined;
  }
}

